import {useViewportSize} from '#hook';

import {EmptyCard} from './EmptyCard';

import * as css from './EmptyHistory.css';

export const EmptyHistory = () => {
  const {isMobile} = useViewportSize();
  return (
    <div className={css.root}>
      <div className={css.cardWrapper}>
        <EmptyCard />
        <EmptyCard />
      </div>
      {!isMobile && (
        <div className={css.cardWrapper}>
          <EmptyCard />
        </div>
      )}
    </div>
  );
};
